<template>
    <div style="display: contents">
        <tr>
            <td :style="{'padding-left': (level*20) + 'px' }">
                <template v-if="hasChildren">
                    <span @click="expanded = false" v-if="expanded" class="cursor-pointer">
                        <fa icon="minus"/>
                    </span>
                    <span @click="expanded = true" v-if="!expanded" class="cursor-pointer">
                        <fa icon="plus"/>
                    </span>
                </template>
                
                {{label}}
            </td>
            <td class="text-right" v-for="(value, key) in data.values" :key="key">
                <template v-if="formatNumbers">
                    {{value | formatInteger}}
                </template>
                <template v-else>
                    {{Math.round(value)}}
                </template>
            </td>
        </tr>
        <template v-for="(value, propertyName, index) in data.children">
            <tree-table-row v-if="expanded" :formatNumbers="formatNumbers" :label="propertyName" :data="value" :level="level + 1" :key="index"></tree-table-row>
        </template>
    </div>
</template>

<script>
import TreeTableRow from './TreeTableRow'

  export default {
    name: 'tree-table-row',
    props: {
        data: {
        },
        label: {

        },
        level: {
            default: 0
        },
        formatNumbers: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        expanded: true
    }),
    computed: {
        hasChildren() {
            return Object.keys(this.data.children).length > 0
        }
    },
    components: {
        TreeTableRow
    }
  }
</script>